"use client";

import { useCallback } from "react";
import { METRICS_EVENTS } from "@cede/types";
import { DISCORD_INVITE_URL } from "@cede/utils";
import { DiscordIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";
import { useMetricsEvents } from "@/hooks/data/useMetricsEvents";
import { ExternalLink, ArrowRight, PartyPopper } from "lucide-react";
import { useRouter } from "next/navigation";

export const CryptoComSignupComplete = () => {
  const router = useRouter();
  const { trackEvent } = useMetricsEvents();

  const handleDiscordClick = useCallback(() => {
    trackEvent(METRICS_EVENTS.CRYPTO_COM_REFEREE_SUPPORT_CLICKED, { target: "discord" });
    window.open(DISCORD_INVITE_URL, "_blank", "noopener,noreferrer");
  }, [trackEvent]);

  const handleBackToHub = useCallback(() => {
    router.push(ROUTES.HOME);
  }, [router]);

  return (
    <div className="flex flex-col items-center gap-4 w-full max-w-[800px] mx-auto animate-fade-in-up">
      <div className="w-full rounded-2xl border border-cede-secondary/20 bg-cede-secondary/[0.04] p-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <PartyPopper className="h-8 w-8 text-cede-secondary" />
          <div>
            <h3 className="text-sm font-semibold text-cede-text-primary">All done! Your submission is under review.</h3>
            <p className="text-xs text-cede-text-secondary mt-1">
              Our team will verify your eligibility and get back to you within 24 hours.
            </p>
          </div>
          <div className="flex items-center gap-3 mt-1">
            <Button
              variant="outline"
              size="small"
              leftIcon={<DiscordIcon className="h-3.5 w-3.5" />}
              rightIcon={<ExternalLink className="h-3 w-3" />}
              onClick={handleDiscordClick}
            >
              Join Discord
            </Button>
            <Button
              variant="ghost"
              size="small"
              rightIcon={<ArrowRight className="h-3.5 w-3.5" />}
              onClick={handleBackToHub}
            >
              View Campaigns
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
